import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa6';
const FAQS = [
    {
        question: 'Histotimeは無料で使えますか？',
        answer: 'はい、Histotimeは無料でダウンロードしてご利用いただけます。すべての基本機能を無料でお使いいただけます。'
    },
    {
        question: 'どんなことを記録できますか？',
        answer: '薬の服用、体調の変化、気分の記録など、不定期に起きるあらゆる出来事を記録できます。フォルダーを自由に作成して、自分だけの記録カテゴリを作れます。'
    },
    {
        question: '習慣トラッカーアプリとの違いは何ですか？',
        answer: '習慣トラッカーは「毎日続ける」ことが目的ですが、Histotimeは「不定期に起きること」を記録するためのアプリです。続けられなくても罪悪感はありません。起きたときに記録するだけです。'
    },
    {
        question: '機種変更時にデータを引き継げますか？',
        answer: 'メールアドレスやSNSアカウントでログインしている場合は、新しい端末でも同じアカウントでログインすることでデータを引き継げます。匿名ログインの場合は引き継ぎができませんのでご注意ください。'
    },
    {
        question: 'Android版はありますか？',
        answer: 'はい、Android版もGoogle Playからダウンロードいただけます。iOS版と同じ機能をご利用いただけます。'
    }
];
const AccordionItem = ({ question, answer, isOpen, onClick })=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "border-b border-gray-200",
        children: [
            /*#__PURE__*/ _jsxs("button", {
                onClick: onClick,
                className: "flex w-full items-center justify-between py-5 text-left",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-lg font-medium text-gray-800",
                        children: question
                    }),
                    /*#__PURE__*/ _jsx(FaChevronDown, {
                        className: `text-teal-600 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: `overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-5' : 'max-h-0'}`,
                children: /*#__PURE__*/ _jsx("p", {
                    className: "leading-relaxed text-gray-600",
                    children: answer
                })
            })
        ]
    });
};
const FAQ = ()=>{
    const [openIndex, setOpenIndex] = useState(0);
    const toggleItem = (index)=>{
        setOpenIndex(openIndex === index ? null : index);
    };
    return /*#__PURE__*/ _jsx("section", {
        className: "bg-gray-50 px-4 py-24 md:px-8",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto max-w-3xl",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "mb-12 text-center text-3xl font-bold text-gray-800 md:text-4xl",
                    children: "よくある質問"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "rounded-2xl bg-white p-6 shadow-lg md:p-8",
                    children: FAQS.map((faq, index)=>/*#__PURE__*/ _jsx(AccordionItem, {
                            question: faq.question,
                            answer: faq.answer,
                            isOpen: openIndex === index,
                            onClick: ()=>toggleItem(index)
                        }, index))
                })
            ]
        })
    });
};
export default FAQ;
